<!--  -->
<template>
  <div class='wrap'>
    <div class="top--wrap">
      <div class="route__name">{{ routeName }}</div>
      <div class="line"
           style="margin: 40px 0;"></div>
      <div class="art__title">
        {{ article.title }}
      </div>
      <div style="font-size: 16px;color:rgba(153, 153, 153, 1);margin-top: 24px;">
        <span>发布日期：{{ article.time }}</span>
        <span style="margin-left: 32px;">来源：{{ article.source }}</span>
      </div>
    </div>
    <div class="detail--wrap">
      <div class="detail__content"
           v-html="article.content"></div>
      <div class="line"></div>
      <div class="oper--wrap">
        <div class="oper__left--wrap">
          <div class="oper__left__item">上一篇：山东省网络安全等级保护制度2.0国家标准在济南宣贯</div>
          <div class="oper__left__item">下一篇：国家密码管理局公告（第37号）</div>
        </div>
        <div class="oper__right--wrap">
          <GButton text="返回列表"
                   width="112px"
                   height="38px"
                   @click="back"></GButton>
        </div>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'ArticleDetailView',
  components: {},
  props: {
    announceId: Number,
    newsId: Number
  },
  data () {
    return {
      article: {
        title: '浪微澜科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道浪微澜科技获超2亿元C轮投资，持续领跑电子认证服务领域赛道',
        time: '2023-07-27 18:21:50',
        source: '工信部官网',
        content: '<span>xxxxxxx</span>'
      }
    }
  },
  computed: {
    routeName () {
      if (this.announceId !== undefined) {
        return '首页/关于我们/公告中心'
      } else {
        return '首页/关于我们/新闻中心'
      }
    }
  },
  watch: {},
  // 方法集合
  methods: {
    back () {
      this.$router.back()
    }
  },
  created () {

  },
  mounted () {

  },
  beforeCreate () { }, // 生命周期 - 创建之前
  beforeMount () { }, // 生命周期 - 挂载之前
  beforeUpdate () { }, // 生命周期 - 更新之前
  updated () { }, // 生命周期 - 更新之后
  beforeDestroy () { }, // 生命周期 - 销毁之前
  destroyed () { }, // 生命周期 - 销毁完成
  activated () { } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.wrap {
  background: rgba(245, 247, 251, 1);
  // padding: 60px 0;
  .top--wrap {
    margin-top: 60px;
    padding: 0 360px;
    background: white;
    padding-bottom: 40px;
    .route__name {
      color: rgba(153, 153, 153, 1);
      font-size: 16px;
    }
  }
  .detail--wrap {
    box-sizing: border-box;
    width: 100%;

    padding: 0 360px;
    background: rgba(245, 247, 251, 1);
    padding-bottom: 40px;
    .detail__content {
      margin-top: 60px;
      box-sizing: border-box;
      padding-bottom: 20px;
      min-height: 100px;
      max-height: 600px;
      overflow: auto;
    }
    .oper--wrap {
      margin-top: 56px;

      display: flex;
      justify-content: space-between;
      align-items: center;
      .oper__left--wrap {
        .oper__left__item {
          margin-top: 4px;
          color: rgba(102, 102, 102, 1);
          font-size: 16px;
          cursor: pointer;
          &:hover {
            color: $color-primary;
          }
        }
      }
    }
  }
}
</style>
